import React from "react";
import { getAssetUrl } from "../../helper/BaseUrl";
export default function DynamicPageAdopt({adoptdata, data}) {
    if (!data?.title) return null;
    const authorImageUrl = getAssetUrl(data?.author_image);
  return (
    <>
      <section className="physical-adopt-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="physical-adopt-box">
                <img src={adoptdata?.firstimg} className="physical-blur" alt="Blur"/>
                <div className="physical-adopt-intro">
                  <img src={adoptdata?.secondimg} alt="Quotes" />
                   {authorImageUrl && <img src={authorImageUrl} alt={data?.author_name || "Author"} />}
                  <div>
                    <span>{data?.author_name}</span>
                    <small>{data?.author_designation}</small>
                  </div>
                </div>
                  <div dangerouslySetInnerHTML={{ __html: data?.quotes }} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
